import AppointmentCalendar from './AppointmentCalendar'

export default AppointmentCalendar